import React from 'react'
import { Container } from './styles'

interface IProps {
  children: React.ReactNode
}

export const ConductAndOmics = ({ children }: IProps): JSX.Element => {
  return <Container>{children}</Container>
}
